import { PERMISSION } from "@app/modules/roles/constants";

export enum AuthEnum {
  AUTH_TOKEN = "x-auth-token",
}

export enum BrandRole {
  ADMIN = "ADMIN",
  READ = "READ",
  NONE = "NONE",
}

export type JwtSchema = {
  name: string;
  id: number;
  brand_id: string;
  email: string;
  phone: string | null;
  user_enabled: boolean;
  created_at: string;
  updated_at: string;
  permissionGroup: PermissionGroup;
  is_two_factor_authentication_enabled: boolean;
  is_two_factor_authenticated: boolean;
  brand_role: BrandRole;
  sub: string;
};

export type PermissionGroup = {
  permissions: PERMISSION[];
  name: string;
  description: string;
  level: PermissionGroupLevel;
  id?: any;
};

export enum PermissionGroupLevel {
  RETAILER = "RETAILER",
  PICKING_POINT = "PICKING_POINT",
  GLOBAL = "GLOBAL",
}
